import { columns } from "../../../../dtos/columns";
import Conversiones from "../../../../utils/conversiones";
import { CobranzaJudicialColumsDTO, CobranzaJudicialDTO, Iprops } from "../models/cobranzaJudicial";


interface IProps {
    controlTabla: any;

}

export function useColumns({controlTabla}: IProps) {
    const COLUMNS: columns<CobranzaJudicialColumsDTO>[] = [
        {
            name: 'N° Operación',
            selector: (row) => row.numeroOperacion,
            sortable: true,
            sortField: 'numeroOperacion',
            wrap: true,
            export: true
        },
        {
            name: 'OMD',
            selector: (row) => row.omd,
            sortable: true,
            sortField: 'omd',
            wrap: true,
            export: true
        },
        {
            name: 'Nombre',
            selector: (row) => row.nombre,
            sortable: true,
            sortField: 'nombre',
            wrap: true,
            export: true
        },
        {
            name: 'RUT solicitante',
            selector: (row) => row.rut,
            sortable: true,
            sortField: 'rut',
            wrap: true,
            export: true
        },

        {
            name: 'Fecha',
            selector: (row) => Conversiones.fechaCortaFormat(row.fecha.toString()),
            sortable: true,
            sortField: 'fecha',
            wrap: true,
            export: true
        },
        {
            name: 'Emisor',
            selector: (row) => row.nombreEmisor,
            sortable: true,
            sortField: 'nombreEmisor',
            wrap: true,
            export: true
        },

    ];

    return { COLUMNS };
}